module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/ee70cddc65fc235bf541f62193badfda.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_calendar.svg
// module id = ZaYO
// module chunks = 0